<!-- 离职业务信息 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :model="dataForm"
             ref="dataForm">
      <!-- 基本信息 -->
      <div class="opten-title"><em class="el-icon-caret-right"></em>{{ $t('user.essentialInformation') }}</div>
      <el-row>
        <el-col :span="6">
          <!-- 证件类型 -->
          <el-form-item :label="$t('user.idtype')"
                        prop="idType">
            <el-select v-model="dataForm.idType"
                       placeholder=""
                       :disabled="true">
              <el-option v-for="(item,index) in idTypeList"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 身份证护照 -->
          <el-form-item :label="$t('user.passportIdcard')"
                        prop="jobStatus">
            <el-input v-model="dataForm.idcard"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 出生日期 -->
          <el-form-item :label="$t('user.dateofbirth')"
                        prop="birthday">
            <el-date-picker v-model="dataForm.birthday"
                            type="date"
                            :disabled="true"
                            placeholder=""
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 性别 -->
          <el-form-item :label="$t('user.gender')"
                        prop="sexCode">
            <el-select v-model="dataForm.sexCode"
                       filterable
                       :disabled="true"
                       placeholder="">
              <el-option v-for="(item,index) in sexCode"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <!-- 姓 -->
          <el-form-item :label="$t('user.firstname')"
                        prop="address">
            <el-input v-model="dataForm.firstName"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 名 -->
          <el-form-item :label="$t('user.lastname')"
                        prop="zipCode">
            <el-input v-model="dataForm.lastName"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 姓名 -->
          <el-form-item :label="$t('user.name')"
                        prop="bmwJoinDate">
            <el-input v-model="dataForm.userName"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 学历 -->
          <el-form-item :label="$t('user.education')"
                        prop="educationCode">
            <el-select v-model="dataForm.educationCode"
                       filterable
                       :disabled="true"
                       placeholder="">
              <el-option v-for="(item,index) in educationCode"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 账号信息 -->
      <div class="opten-title"><em class="el-icon-caret-right"></em>{{ $t('user.accountinformation') }}</div>
      <el-row>
        <el-col :span="6">
          <div class="img-div">
            <img alt="" :src="dataForm.headurl" />
          </div>
        </el-col>
        <el-col :span="18">
          <el-row class="row-mar-l">
            <el-col :span="8">
              <!-- 用户id -->
              <el-form-item :label="$t('user.userID')"
                            prop="userId">
                <el-input v-model="dataForm.userCode"
                          :disabled="true"
                          placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 员工号 -->
              <el-form-item :label="$t('user.userCardNo')"
                            prop="userCardNo">
                <el-input v-model="dataForm.userCardNo"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 同意收集隐私 -->
              <el-form-item :label="$t('user.agreeconceal')"
                            prop="agreePolicy">
                <el-select v-model="dataForm.agreePolicy"
                           filterable
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in agreePolicy"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="8">
              <!-- 组织类型 -->
              <el-form-item :label="$t('organization.orgType')"
                            prop="orgType">
                <el-select v-model="dataForm.orgType"
                           filterable
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in orgTypeArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="idcard">
                <el-select v-model="dataForm.authType"
                           filterable
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in perClassification"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 手机 -->
            <el-col :span="8">
              <el-form-item :label="$t('user.mobile')"
                            prop="mobile">
                <el-input v-model="dataForm.mobile"
                          :disabled="true"
                          placeholder=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="row-mar-l">
        <el-col :span="6">
          <!-- 最后登录时间 -->
          <el-form-item :label="$t('user.lastlogintime')"
                        prop="mobile">
            <el-input v-model="dataForm.lastLoginTime"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 最后修改密码时间 -->
          <el-form-item :label="$t('user.lastPassword')">
            <el-input v-model="dataForm.passwordUpdateTime"
                      :placeholder="$t('user.null')"
                      :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 是否允许登录 -->
          <el-form-item :label="$t('user.status10')"
                        prop="loginFlag">
            <el-select v-model="dataForm.loginFlag"
                       clearable
                       :disabled="true"
                       :placeholder="$t('user.select')">
              <el-option v-for="(item,index) in leafFlag"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 邮箱 -->
          <el-form-item :label="$t('user.userEmail')"
                        prop="email">
            <el-input v-model="dataForm.email"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row-mar-l">
        <!-- 紧急联系人及联系方式 -->
        <el-col :span="6">
          <el-form-item :label="$t('user.emergencyContact')"
                        prop="emergencyContactInfo">
            <el-input v-model="dataForm.emergencyContactInfo"
                      placeholder=""
                      :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 业务信息 -->
      <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.business')}}</div>
      <el-row>
        <el-col :span="6">
          <!-- 服务宝马开始时间 -->
          <el-form-item :label="$t('organization.joinDateBmw')"
                        prop="value">
            <el-date-picker v-model="dataForm.bmwJoinDate"
                            type="date"
                            :disabled="true"
                            placeholder=""
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 在职状态 -->
          <el-form-item :label="$t('user.incumbency')"
                        prop="leaveDate">
            <el-select placeholder=""
                       v-model="dataForm.jobStatus"
                       :disabled="true">
              <el-option v-for="(item,index) in jobStatus"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 加入当前公司时间 -->
          <el-form-item :label="$t('user.accessionDate')"
                        prop="jobCode">
            <el-date-picker v-model="dataForm.orgJoinDate"
                            type="date"
                            :disabled="true"
                            placeholder=""
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 离职日期 -->
          <el-form-item :label="$t('user.leaveDate')"
                        prop="value">
            <el-date-picker v-model="dataForm.leaveDate"
                            type="date"
                            :disabled="true"
                            placeholder=""
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <!-- 宝龄 -->
          <el-form-item :label="$t('user.BMWtime')"
                        prop="networkJoinDate">
            <el-input v-model="dataForm.bmwSeniority"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"
                style="text-align:center">
          <!-- 角色 -->
          <el-form-item class="role-div"
                        :label="$t('user.role')"
                        prop="roleName"
                        style="width:90% !important">
            <el-input type="textarea"
                      autosize
                      placeholder=""
                      v-model="roleIds"
                      :disabled="true">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 宝马集团 -->
      <div v-if="dataForm.orgType === '10'">
        <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.GWMinformation')}}</div>
        <el-row>
          <el-col :span="6">
            <!-- 所属公司 -->
            <el-form-item :label="$t('user.GWMcompany')">
              <!-- 公司 -->
              <el-select placeholder=""
                         v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="(item,index) in companyResults"
                           :key="index"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 部门 -->
            <el-form-item :label="$t('user.department')">
              <el-input v-model="dataForm.bmwDeptCode"
                        :disabled="true"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 宝马集团职位 -->
            <el-form-item :label="$t('user.position')">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="dataForm.jobCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 合作院校/合作伙伴，best学员 -->
      <div v-if="dataForm.orgType === '20' || dataForm.orgType === '30'">
        <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('organization.orgType2030')}}</div>
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('user.GWMcompany')">
              <!-- 所属公司 -->
              <el-select placeholder=""
                         v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="(item,index) in companyResults"
                           :key="index"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 合作伙伴职位 -->
            <el-form-item :label="$t('user.position')">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="dataForm.jobCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- BEST学员信息 -->
        <el-row class="row-mar-l"
                v-if="dataForm.authType === '50' && false">
          <el-col :span="6">
            <!-- 预签约经销商 -->
            <el-form-item :label="$t('user.reservedDistributor')"
                          prop="dealerShipId">
              <el-select v-model="dataForm.dealerShipId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="(item,index) in orgResulets"
                           :key="index"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 是否正式账号 -->
            <el-form-item :label="$t('user.numberbankaccount')"
                          prop="officialAccountFlag">
              <el-select v-model="dataForm.officialAccountFlag"
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in regulArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 在校状态 -->
            <el-form-item :label="$t('user.graduation')"
                          prop="graduateStatus">
              <el-select v-model="dataForm.graduateStatus"
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in graduationStatus"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="dataForm.graduateStatus === '10'">
            <!-- 入校时间 -->
            <el-form-item :label="$t('user.joinschool')"
                          prop="enterSchoolDate">
              <el-date-picker v-model="dataForm.enterSchoolDate"
                              type="date"
                              :placeholder="$t('user.checkdate')"
                              value-format="yyyy-MM-dd"
                              :disabled="true">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="dataForm.graduateStatus === '20' || dataForm.graduateStatus === '30'">
            <!-- 离校时间 -->
            <el-form-item :label="$t('user.leaveschool')"
                          prop="leaveSchoolDate">
              <el-date-picker v-model="dataForm.leaveSchoolDate"
                              type="date"
                              :placeholder="$t('user.checkdate')"
                              value-format="yyyy-MM-dd"
                              :disabled="true">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 经销商集团 -->
      <div v-if="dataForm.orgType === '40'">
        <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.dealerGroupInformation')}}</div>
        <el-row>
          <el-col :span="6">
            <!-- 所属公司 -->
            <el-form-item :label="$t('user.GWMcompany')">
              <!-- 公司 -->
              <el-select placeholder=""
                         v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="(item,index) in companyResults"
                           :key="index"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 经销商集团职位 -->
            <el-form-item :label="$t('user.position')">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="dataForm.jobCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 经销商信息 -->
      <div v-if="dataForm.orgType === '60'">
        <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.dealer')}}</div>
        <el-row>
          <el-col :span="6">
            <!-- 所属经销商网点 -->
            <el-form-item :label="$t('user.outlet')"
                          prop="orgId">
              <el-select placeholder=""
                         v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="item in results"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 所属品牌 -->
            <el-form-item :label="$t('user.brandCodes')"
                          prop="">
              <el-input v-model="dataForm.brandCode"
                        :disabled="true"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 所属NSC No -->
            <el-form-item :label="$t('user.nscno')"
                          prop="">
              <el-input v-model="dataForm.nscNo"
                        :disabled="true"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 所属BBA No -->
            <el-form-item :label="$t('user.bbaNo')"
                          prop="">
              <el-input v-model="dataForm.bbaNo"
                        :disabled="true"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <el-col :span="6">
            <!-- 网点类型 -->
            <el-form-item :label="$t('user.outletType')"
                          prop="">
              <el-input v-model="dataForm.outletType"
                        placeholder=""
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 当前岗龄 -->
            <el-form-item :label="$t('user.jobyear')"
                          prop="">
              <el-input v-model="dataForm.jobcodeAge"
                        placeholder=""
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 主要职位 -->
            <el-form-item :label="$t('user.position')"
                          prop="jobCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="dataForm.jobCode === '' || !dataForm.jobCode">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="dataForm.jobCode"
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 加入该职位日期 -->
            <el-form-item :label="$t('user.joinjobdate')"
                          prop="jobcodeJoinDate">
              <el-date-picker v-model="dataForm.jobcodeJoinDate"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 离开该职位日期 -->
            <el-form-item :label="$t('user.leavejobdate')"
                          prop="jobcodeLeaveDate">
              <el-date-picker v-model="dataForm.jobcodeLeaveDate"
                              type="date"
                              placeholder=""
                              :disabled="true"
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职1所属网点 -->
            <el-form-item :label="$t('user.outlet1')"
                          prop="partTimeOutletOne">
              <el-select v-model="dataForm.partTimeOutletOne"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults0"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职1 -->
            <el-form-item :label="$t('user.parttimejob1')"
                          prop="partTimeJobcodeOne">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="dataForm.partTimeJobcodeOne === '' || !dataForm.partTimeJobcodeOne">
                <div slot="content"
                     v-html="jobCodeContentOne"></div>
                <el-select placeholder=""
                           v-model="dataForm.partTimeJobcodeOne"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList0"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 加入兼职1日期 -->
            <el-form-item :label="$t('user.joinparttimejob1')"
                          prop="jobcodeJoinDateOne">
              <el-date-picker v-model="dataForm.jobcodeJoinDateOne"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 离开兼职1日期 -->
            <el-form-item :label="$t('user.leaveparttimejob1')"
                          prop="updateTime">
              <el-date-picker v-model="dataForm.jobcodeLeaveDateOne"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职2所属网点 -->
            <el-form-item :label="$t('user.outlet2')"
                          prop="partTimeOutletTwo">
              <el-select v-model="dataForm.partTimeOutletTwo"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults1"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职2 -->
            <el-form-item :label="$t('user.parttimejob2')"
                          prop="partTimeJobcodeTwo">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="dataForm.partTimeJobcodeTwo === '' || !dataForm.partTimeJobcodeTwo">
                <div slot="content"
                     v-html="jobCodeContentTwo"></div>
                <el-select placeholder=""
                           v-model="dataForm.partTimeJobcodeTwo"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList1"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 加入兼职2日期 -->
            <el-form-item :label="$t('user.joinparttimejob2')"
                          prop="deleteStatus">
              <el-date-picker v-model="dataForm.jobcodeJoinDateTwo"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 离开兼职2日期 -->
            <el-form-item :label="$t('user.leaveparttimejob2')"
                          prop="deleteStatus">
              <el-date-picker v-model="dataForm.jobcodeLeaveDateTwo"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职3所属网点 -->
            <el-form-item :label="$t('user.outlet3')"
                          prop="partTimeOutletThree">
              <el-select v-model="dataForm.partTimeOutletThree"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults2"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职3 -->
            <el-form-item :label="$t('user.parttimejob3')"
                          prop="partTimeJobcodeTwo">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="dataForm.partTimeJobcodeThree === '' || !dataForm.partTimeJobcodeThree">
                <div slot="content"
                     v-html="jobCodeContentThree"></div>
                <el-select placeholder=""
                           v-model="dataForm.partTimeJobcodeThree"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList2"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 加入兼职3日期 -->
            <el-form-item :label="$t('user.joinparttimejob3')"
                          prop="deleteStatus">
              <el-date-picker v-model="dataForm.jobcodeJoinDateThree"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 离开兼职3日期 -->
            <el-form-item :label="$t('user.leaveparttimejob3')"
                          prop="deleteStatus">
              <el-date-picker v-model="dataForm.jobcodeLeaveDateThree"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职4所属网点 -->
            <el-form-item :label="$t('user.outlet4')"
                          prop="partTimeOutletFour">
              <el-select v-model="dataForm.partTimeOutletFour"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults3"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职4 -->
            <el-form-item :label="$t('user.parttimejob4')"
                          prop="partTimeJobcodeFour">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="dataForm.partTimeJobcodeFour === '' || !dataForm.partTimeJobcodeFour">
                <div slot="content"
                     v-html="jobCodeContentFour"></div>
                <el-select placeholder=""
                           v-model="dataForm.partTimeJobcodeFour"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList3"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 加入兼职4日期 -->
            <el-form-item :label="$t('user.joinparttimejob4')"
                          prop="deleteStatus">
              <el-date-picker v-model="dataForm.jobcodeJoinDateFour"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 离开兼职4日期 -->
            <el-form-item :label="$t('user.leaveparttimejob4')"
                          prop="deleteStatus">
              <el-date-picker v-model="dataForm.jobcodeLeaveDateFour"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职5所属网点 -->
            <el-form-item :label="$t('user.outlet5')"
                          prop="partTimeOutletFive">
              <el-select v-model="dataForm.partTimeOutletFive"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults4"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职5 -->
            <el-form-item :label="$t('user.parttimejob5')"
                          prop="partTimeJobcodeFive">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="dataForm.partTimeJobcodeFive === '' || !dataForm.partTimeJobcodeFive">
                <div slot="content"
                     v-html="jobCodeContentFive"></div>
                <el-select placeholder=""
                           v-model="dataForm.partTimeJobcodeFive"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList4"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 加入兼职5日期 -->
            <el-form-item :label="$t('user.joinparttimejob5')"
                          prop="deleteStatus">
              <el-date-picker v-model="dataForm.jobcodeJoinDateFive"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 离开兼职5日期 -->
            <el-form-item :label="$t('user.leaveparttimejob5')"
                          prop="deleteStatus">
              <el-date-picker v-model="dataForm.jobcodeLeaveDateFive"
                              type="date"
                              :disabled="true"
                              placeholder=""
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-form label-position="top"
             :model="dismissionForm"
             :rules="dataRule"
             ref="dismissionForm">
      <!-- 离职信息 -->
      <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.dimissionMessage')}}</div>

      <el-row class="row-mar-l">
        <!-- 离职日期 -->
        <el-col :span="6">
          <el-form-item :label="$t('dimission.dimissionDate')"
                        prop="dimissionDate">
            <el-date-picker v-model="dismissionForm.dimissionDate"
                            type="date"
                            :placeholder="$t('dimission.dimissionDate')"
                            value-format="yyyy-MM-dd"
                            :disabled="isDisable">
            </el-date-picker>
          </el-form-item>
        </el-col>

     <!-- 离职方式 -->
      <el-col :span="6"
                v-if="dataForm.orgType === '60'  || dataForm.orgType === '30'">
          <el-form-item :label="$t('dimission.dimissionType')"
                        prop="dimissionTypeHr">
            <el-select v-model="dismissionForm.dimissionTypeHr"
                       :placeholder="$t('user.select')"
                       :disabled="isDisable"
                       @change="GetcourseTeamCatalog($event)"
                       clearable>
              <el-option v-for="(item,index) in dimissionType"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- hr离职原因 -->
        <el-col :span="6"
                v-if="dataForm.orgType === '60'  || dataForm.orgType === '30'">
          <el-form-item :label="$t('dimission.dimissionReason')"
                        prop="dimissionReasonHr">
            <el-select v-model="dismissionForm.dimissionReasonHr"
                       :placeholder="$t('user.select')"
                       :disabled="!dismissionForm.dimissionTypeHr && !isDisable || isDisable"
                       clearable>
              <el-option v-for="(item,index) in select2"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      <el-col :span="6"
                v-if="dataForm.orgType === '60' || dataForm.orgType === '30'">
          <!-- 离职去向 -->
          <el-form-item :label="$t('dimission.dimissionWhereAbout')"
                        prop="dimissionWhereAboutHr">
            <el-select v-model="dismissionForm.dimissionWhereAboutHr"
                       :placeholder="$t('user.select')"
                       :disabled="isDisable"
                       clearable>
              <el-option v-for="(item,index) in dimissionWhereAbout"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style='margin-top:20px' v-if="dataForm.orgType === '60'  || dataForm.orgType === '30'">
       <!-- 是否推荐人才 -->
        <el-col :span="6"
                v-if="dataForm.orgType === '60' || dataForm.orgType === '30'">
          <el-form-item :label="$t('dimission.recommendFlag')"
                        prop="recommendFlag">
            <el-select v-model="dismissionForm.recommendFlag"
                       placeholder=""
                       :disabled="isDisable"
                       clearable>
              <el-option v-for="(item,index) in recommendFlagArr"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 占位 -->
          <el-form-item label="">
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 离职原因其他 -->
          <el-form-item label="其他原因"
                        v-if="dismissionForm.dimissionReasonHr == 120"
                        prop="reasonContentHr">
            <el-input v-model="dismissionForm.reasonContentHr"
                      type="textarea"
                      maxlength="100"
                      show-word-limit
                      :disabled="isDisable"
                      :rows="4"></el-input>
          </el-form-item>
          <el-form-item label=""
                        v-else>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 离职去向其他 -->
          <el-form-item v-if="dismissionForm.dimissionWhereAboutHr == '30' || dismissionForm.dimissionWhereAboutHr == '80'" prop="reasonWhereAboutContentHr"
                        label="请填写">
            <el-input v-model="dismissionForm.reasonWhereAboutContentHr"
                      type="textarea"
                      maxlength="80"
                      show-word-limit
                      :disabled="isDisable"
                      :rows="4"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 占位 -->
          <el-form-item v-if="dismissionForm.dimissionWhereAboutHr == 20" prop="reasonNewEnergyContentHr"
                        label="请填写名称">
            <el-select v-model="dismissionForm.reasonNewEnergyContentHr"
                       :placeholder="$t('user.select')"
                       :disabled="isDisable"
                       clearable>
              <el-option v-for="(item,index) in newEnergy"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="dataForm.orgType === '60'  || dataForm.orgType === '30'">
        <el-col :span="6">
          <!-- 点亮小星星 -->
          <el-form-item label="">
            <span style="white-space:nowrap;">温馨提示：<br />选择是，为该员工点亮小星星，<br />让更多的HR关注他/她。</span>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

  </el-card>
</template>

<script>
import Vue from 'vue'
import AesUtil from "@/utils/aes_utils";
export default {
  props: {
    createDate: {
      type: String
    }
  },
  data() {
    return {
      // 判断表单是否可以编辑 userRole=hradminAudit false userRole=areaAudit true
      isDisable: true,
      // 用户信息
      dataForm: {},
      // 所属经销商网点
      results: [],
      // 职位列表
      positionlist: [],
      // 兼职网点
      partResults0: [],
      partResults1: [],
      partResults2: [],
      partResults3: [],
      partResults4: [],
      // 兼职列表
      parttimejobList0: [],
      parttimejobList1: [],
      parttimejobList2: [],
      parttimejobList3: [],
      parttimejobList4: [],
      // 宝马集团，合作伙伴，合作院校公司列表
      companyResults: [],
      // 预留经销商
      orgResulets: [],
      // 在职状态
      jobStatus: this.enums['jobStatus'],
      // 审批流程
      registration: this.enums['registration'],
      // 组织类型回显
      orgTypeArr: this.enums['orgType'],
      // 性别
      sexCode: this.enums['sex'],
      // 学历回显
      educationCode: this.enums['educationCode'],
      // 是否同意
      agreePolicy: this.enums['agreePolicy'],
      // 同意登录
      loginFlag: this.enums['loginFlag'],
      // 权限分类
      perClassification: this.enums['perClassification'],
      // 在职状态
      status: this.enums['status'],
      // 品牌
      brandCode: this.enums['brandCode'],
      // 证件类型
      idTypeList: this.enums['idType'],
      // 离职原因
      dimissionReasonArr: this.enums['dimissionReason'],
      // 离职方式
      dimissionType: this.enums['dimissionType'],
      // 离职去向
      dimissionWhereAbout: this.enums['dimissionWhereAbout'],
      //离职去向新能源公司
      newEnergy: this.enums['newEnergy'],
      select2: [],
      // 是否允许登录
      leafFlag: this.enums['confirmState'],
      // 是否推荐人才库
      recommendFlagArr: this.enums['confirmState'],
      // 毕业状态
      graduationStatus: this.enums['graduationStatus'],
      // 是否正式账号
      regulArr: this.enums['confirmState'],
      // 角色
      roleIds: '',
      // 主要职位描述code
      jobCodeNum: this.$t('activiti.jobCodeNum'),
      jobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 兼职职位描述code
      jobCodeNumOne: this.$t('activiti.jobCodeNum'),
      jobCodeNumTwo: this.$t('activiti.jobCodeNum'),
      jobCodeNumThree: this.$t('activiti.jobCodeNum'),
      jobCodeNumFour: this.$t('activiti.jobCodeNum'),
      jobCodeNumFive: this.$t('activiti.jobCodeNum'),
      jobCodeContentOne: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentTwo: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentThree: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFour: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFive: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 离职信息
      dismissionForm: {
        dimissionDate: '',
        dimissionReason: '',
        dimissionReasonHr: '',
        dimissionTypeHr: '',
        dimissionWhereAboutHr: '',
        reasonWhereAboutContentHr: '',
        //新能源公司
        reasonNewEnergyContentHr: '',
        reasonContent: '',
        reasonContentHr: '',
        recommendFlag: '10'
      },
      // 主页面是否通过，用于子页面表单验证
      canUpdate: false,
      smallDate: '',
      bigDate: '',
      privacyFileUrl: '',
      buttonShow: '', // 是否显示返回按钮
      nowDate: ''
    }
  },
  computed: {
    dataRule() {
      // 离职日期校验 发起日期的（1-30）天，且不早于当前日期
      let validatordimissionDate = (rule, value, callback) => {
        console.warn(this.createDate)
        let today = new Date(Date.parse(value.replace(/-/g, '/'))).getTime()
        let nowDay = new Date(Date.parse(this.nowDate.replace(/-/g, '/'))).getTime()
        let sevenday = new Date(Date.parse(this.createDate.replace(/-/g, '/'))).getTime() + 3600 * 1000 * 24 * (this.smallDate - 1)
        let thirtyday = new Date(Date.parse(this.createDate.replace(/-/g, '/'))).getTime() + 3600 * 1000 * 24 * this.bigDate
        if (today < nowDay || today <= sevenday || today >= thirtyday) {
          callback(new Error(this.$t('user.validatorsevendimissionDate1') + this.smallDate + this.$t('user.validatorsevendimissionDate3') + this.bigDate + this.$t('user.validatorsevendimissionDate2')))
        } else {
          callback()
        }
        callback()
      }
      return {
        // 离职日期
        dimissionDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
          { validator: validatordimissionDate, trigger: 'change' }
        ],
        // 离职原因
        dimissionReasonHr: [
          { required: true, message: this.$t('user.validatorDimissionReason'), trigger: 'change' }
        ],
        // 其他离职原因
        reasonContentHr: [
          { required: true, message: this.$t('user.validatorDimissionReasonContent'), trigger: 'blur' }
        ],
        // 离职方式
        dimissionTypeHr: [
          { required: true, message: this.$t('user.validatorDimissionType'), trigger: 'change' }
        ],
        // 离职去向
        dimissionWhereAboutHr: [
          { required: true, message: this.$t('user.validatorDimissionWhereAbout'), trigger: 'change' }
        ],
        // 其他离职去向原因
        reasonWhereAboutContentHr: [
          { required: true, message: this.$t('user.validatorDimissionReasonContentWhereAbout'), trigger: 'blur' }
        ],
        //离职去向新能源公司
        reasonNewEnergyContentHr: [
          { required: true, message: this.$t('user.validatorDimissionReasonContentNewEnergy'), trigger: 'blur' }
        ]
      }
    }
  },
  // 页面初始化
  activated() {
    this.$nextTick(() => {
      if (this.$refs.dataForm) {
        this.$refs['dataForm'].resetFields()
      }
      if (this.$refs.dismissionForm) {
        this.$refs['dismissionForm'].resetFields()
      }
      if (this.$route.query.dimissionId !== undefined) {
        this.dismissionForm.dimissionId = this.$route.query.dimissionId
      }
      this.getDimissionInfo()

      if (this.$route.query.buttonShow) {
        this.buttonShow = this.$route.query.buttonShow
      }
    })
  },
  methods: {
    // 获取离职信息
    getDimissionInfo() {
      this.$request.get(`/sys/dimission/info/${this.dismissionForm.dimissionId}`).then((res, total, code, data) => {
        this.dismissionForm = {
          ...this.dismissionForm,
          ...res
        }

        if (this.dismissionForm.dimissionReason && !this.dismissionForm.recommendFlag && this.dismissionForm.recommendFlag !== '') {
          this.dismissionForm.recommendFlag = '10'
        }

        this.$nextTick(() => {
          this.$refs['dismissionForm'].clearValidate()
        })
        if (this.$route.query.approval) {
          if (this.$route.query.approval + '' === '1') {
            if (this.dismissionForm.dimissionReason) {
              this.isDisable = false
            } else {
              this.isDisable = true
            }
          } else {
            this.isDisable = true
          }
        } else {
          this.isDisable = true
        }
        if(!this.dismissionForm.dimissionTypeHr && !this.dismissionForm.dimissionReasonHr && this.isDisable==false){
          console.log('222222222222222')
          this.dismissionForm.dimissionTypeHr=this.dimissionType[0].code
          this.GetcourseTeamCatalog(this.dismissionForm.dimissionTypeHr)
        }
        if (res.userId && res.userId !== '') {
          this.dataForm.userId = res.userId
          this.getUserInfo()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
     // 表单提交-非空检验
    dataFormSubmitHandle() {
      if(this.isDisable==false){
        this.$refs['dismissionForm'].validate((valid) => {
        if (!valid) {
          this.canUpdate = false
          return false
        }
        this.canUpdate = true
      })
      }else{
        this.canUpdate = true
      }
    },
    // 获取用户信息
    getUserInfo() {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.dataForm.userId + ''))
      this.$request.get(`/sys/commuser/infomt/${userId}`).then((res, total, code, data) => {
        if (res.birthday && res.birthday !== '') {
          res.birthday = Vue.filter('formatDateNoTime')(res.birthday)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res
        }
        // 拼接隐私协议相对路径
        if (this.dataForm.privacyFileUrl && this.dataForm.privacyFileUrl !== '') {
          this.privacyFileUrl = this.dataForm.uploadHost + this.dataForm.privacyFileUrl
        } else {
          this.privacyFileUrl = ''
        }
        // 赋值网点类型
        this.dataForm.outletType = Vue.filter('coverEnumList')(this.dataForm.networkType, 'networkType', ',')
        // 算岗龄
        let joinDate = Vue.filter('theTime')(this.dataForm.jobcodeJoinDate)
        if (!this.dataForm.jobcodeJoinDate) {
          joinDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
        }
        let now = Date.parse(new Date())
        if (this.dataForm.jobStatus === '20') {
          if (this.dataForm.leaveDate && this.dataForm.leaveDate !== '') {
            now = Vue.filter('theTime')(this.dataForm.leaveDate)
          }
        }
        // 时间差
        let dateDeviation = parseInt(Math.abs(now - joinDate) / 1000 / 60 / 60 / 24, 10)
        this.dataForm.jobcodeAge = dateDeviation
        // 计算宝龄
        let currentVersionDate = 0
        let bmwDateDeviation = 0
        // 如果在职
        if (this.dataForm.jobStatus === '10') {
          if (this.dataForm.currentVersionDate) {
            currentVersionDate = Vue.filter('theTime')(this.dataForm.currentVersionDate)
            bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
          } else {
            if (this.dataForm.orgJoinDate) {
              currentVersionDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
              bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
            }
          }
          this.dataForm.bmwSeniority = bmwDateDeviation + Number(this.dataForm.bmwSeniority)
        }
        this.dataForm.bmwSeniority = (this.dataForm.bmwSeniority / 365).toFixed(2)
        this.dataForm.registrationApprovaStatus = this.dataForm.registrationApprovaStatus + ''
        this.$request.get(`/sys/commuser/sysRoleMT`,
          {
            orgType: this.dataForm.orgType,
            authType: this.dataForm.authType
          }
        ).then((res, total, code, data) => {
          this.rolelist = data.result.map(item => {
            item.roleId = item.roleId + ''
            return item
          })
          let newRolelist = ''
          if (this.dataForm.roleId !== '' && this.dataForm.roleId !== null && this.dataForm.roleId !== undefined) {
            let roleIdList = this.dataForm.roleId.split(',')
            for (let a = 0; a < roleIdList.length; a++) {
              for (let i = 0; i < this.rolelist.length; i++) {
                if (this.rolelist[i].roleId === roleIdList[a]) {
                  newRolelist += this.rolelist[i].roleName + '，'
                }
              }
            }
            newRolelist = newRolelist.substr(0, newRolelist.length - 1)
          }
          this.roleIds = newRolelist
        }).catch((err) => {
          console.log(err)
        })
        if (this.dataForm.orgType === '60') {
          if (this.dataForm.partTimeJobcodeOne && this.dataForm.partTimeJobcodeOne !== '') {
            // 兼职1网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.dataForm.partTimeOutletOne,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults0 = res
            }).catch((err) => {
              console.log(err)
            })

            // 兼职1职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.dataForm.partTimeJobcodeOne + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList0 = res
              this.jobCodeNumOne = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.dataForm.partTimeJobcodeTwo && this.dataForm.partTimeJobcodeTwo !== '') {
            // 兼职2网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.dataForm.partTimeOutletTwo,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults1 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职2职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.dataForm.partTimeJobcodeTwo + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList1 = res
              this.jobCodeNumTwo = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.dataForm.partTimeJobcodeThree && this.dataForm.partTimeJobcodeThree !== '') {
            // 兼职3网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.dataForm.partTimeOutletThree,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults2 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职3职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.dataForm.partTimeJobcodeThree + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList2 = res
              this.jobCodeNumThree = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.dataForm.partTimeJobcodeFour && this.dataForm.partTimeJobcodeFour !== '') {
            // 兼职4网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.dataForm.partTimeOutletFour,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults3 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职4职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.dataForm.partTimeJobcodeFour + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList3 = res
              this.jobCodeNumFour = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.dataForm.partTimeJobcodeFive && this.dataForm.partTimeJobcodeFive !== '') {
            // 兼职5网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.dataForm.partTimeOutletFive,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults4 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职5职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.dataForm.partTimeJobcodeFive + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList4 = res
              this.jobCodeNumFive = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
        }
        // 如果有已选预签约，下拉列表只显示当前选项，因为输入下拉的列表默认只显示10个，可能无法正常回显
        if (this.dataForm.dealerShipId && this.dataForm.dealerShipId !== '') {
          this.$request.get(`/sys/org/info/${this.dataForm.dealerShipId}`).then((res, total, code, data) => {
            this.orgResulets = []
            this.orgResulets.push(res)
          }).catch((err) => {
            console.log(err)
          })
        }
        this.$request.get('/sys/org/selectOrgByParam',
          {
            orgId: this.dataForm.orgId,
            orgType: this.dataForm.orgType
          }
        ).then((res, total, code, data) => {
          // 经销商时需要回显品牌
          if (this.dataForm.orgType === '60') {
            var brandCodes = res[0].brandCodes
            this.dataForm.brandCode = Vue.filter('coverEnumList')(brandCodes, 'brandCode', ',')
            this.results = res
          } else {
            this.companyResults = res
          }
        }).catch((err) => {
          console.log(err)
        })
        // 根据jobCode回显主职
        if (this.dataForm.jobCode && this.dataForm.jobCode !== '') {
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.jobCode + ''
            }
          ).then((res, total, code, data) => {
            this.positionlist = res
            if (res[0]) {
              this.jobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + '<br/>' + res[0].positionDesc.replace(/\n/g, "<br>")
              } else {
                this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 返回按钮
    backPage() {
      this.tabRemove(this.$store.state.contentTabsActiveName)
    },
    // 删除当前Tag页，返回待办列表
    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 从离职列表审批，返回离职列表
      this.$router.push({
        name: 'sys-dimission'
      })
    },
    GetcourseTeamCatalog (prov) {
                let tempArry = []
                this.select2 = []
                if (this.dismissionForm.dimissionReasonHr !== null || this.dismissionForm.dimissionReasonHr === '') {
                    this.dismissionForm.dimissionReasonHr = ''
                }
                for (var val of this.dimissionReasonArr) {
                    var co=val.code
                    if(co==120){
                      continue
                    }
                    var code = val.code.slice(0, 2)
                    if (prov === code) {
                        tempArry.push({ name: val.name, code: val.code })
                    }
                    this.select2 = tempArry
                }
                if(prov == '20'){
                  this.dismissionForm.dimissionReasonHr= this.select2[0].code
                }
            }
  },
  mounted() {
    this.select2=this.dimissionReasonArr
    this.$request.get('/sys/config/list',
      {
        getDataListIsPage: false
      }).then((res, total, code, data) => {
        this.dataList = res
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].paramKey === 'LEAVE_DATE_MIN_WEB') {
            this.smallDate = this.dataList[i].paramValue
          }
          if (this.dataList[i].paramKey === 'LEAVE_DATE_MAX') {
            this.bigDate = this.dataList[i].paramValue
          }
        }
      }).catch(() => { })
    this.$request.get('/sys/getServerTime').then((res, total, code, data) => {
      this.nowDate = res.date
    }).catch(() => { })
  }
}
</script>
<style lang="scss" scoped>
li {
  list-style: none;
}
.img-div {
  text-align: center;
  width: 142px;
  img {
    width: 100%;
    min-height: 100px;
  }
  .modify-img {
    cursor: pointer;
    margin-top: 10px;
  }
}
</style>
